import React from 'react';
import { MDAWorksheetSelectorFormState } from './MDAWorksheetSelector';

export enum RecordMode {
    VIEW = 'VIEW',
    NEW_RECORD = 'NEW_RECORD',
    UPDATE_EXISTING = 'UPDATE_EXISTING',
}

export type WizardStepComponent<T> = React.FC<WizardStepComponentProps<T>>;

export interface WizardStepComponentProps<T> {
    onSave: (data: Partial<T>) => void;
    onCancel?: () => void;
    onBack?: () => void;
    initialData?: Partial<T>;
    recordMode?: RecordMode;
    executionGroupNumber?: string;
}

export { WorksheetSelectionTable } from './WorksheetSelectionTable';
export { DataSourceSelectionTable } from './DataSourceSelectionTable';
export { SourceLineSelectionTable } from './SourceLineSelectionTable';
